var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c(
        "div",
        {
          class: `loading-overlay ${_vm.isBlue ? "blue-loading-overlay" : ""} ${
            _vm.isWhite ? "white-loading-overlay" : ""
          }`
        },
        [
          _vm._m(0),
          _vm.text
            ? _c("div", { staticClass: "loading-main-text" }, [
                _vm._v(" " + _vm._s(_vm.text) + " ")
              ])
            : _vm._e(),
          _vm.description
            ? _c("div", { staticClass: "loading-description" }, [
                _vm._v(" " + _vm._s(_vm.description) + " ")
              ])
            : _vm._e(),
          _vm.buttonText
            ? _c(
                "button",
                {
                  staticClass: "cancel-loading-button",
                  on: { click: _vm.onCancelClick }
                },
                [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-image" }, [
      _c("img", {
        staticClass: "stage-1",
        attrs: {
          src: require("@/common/assets/icons/loading/Loading_akkodis_logo_1.svg"),
          alt: "platform"
        }
      }),
      _c("img", {
        staticClass: "stage-2",
        attrs: {
          src: require("@/common/assets/icons/loading/Loading_akkodis_logo_2.svg"),
          alt: "platform"
        }
      }),
      _c("img", {
        staticClass: "stage-3",
        attrs: {
          src: require("@/common/assets/icons/loading/Loading_akkodis_logo_3.svg"),
          alt: "platform"
        }
      }),
      _c("img", {
        staticClass: "stage-4",
        attrs: {
          src: require("@/common/assets/icons/loading/Loading_akkodis_logo_4.svg"),
          alt: "platform"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }